import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { useGetDatasetFilesQuery, useGetDatasetInstructionsQuery } from '~/api/v2/hooks';
import { FileUploader } from '~/components';
import { ConnectionInstructionsType } from '~/components/ConnectionInstructions/types';
import { useAppDispatch } from '~/redux';
import { ModalTypesEnum, openModal } from '~/redux/slices/modalSlice';

interface ImportDataStepProps {
  files: File[];
  onFilesUpload: (files: File[] | null) => void;
}

const ImportDataStep: FC<ImportDataStepProps> = ({ files, onFilesUpload }) => {
  const datasetId = +useParams().id!;
  const dispatch = useAppDispatch();
  const { data, isLoading } = useGetDatasetFilesQuery({ datasetId });
  const { data: datasetConnection } = useGetDatasetInstructionsQuery({
    datasetId,
  });

  return (
    <Box>
      <FileUploader
        existingFiles={data || []}
        existingFilesLoading={isLoading}
        currentFiles={files}
        onChange={onFilesUpload}
        filesToImport="Data files"
        buttonLabel="Upload data"
        secondaryButtonLabel="Upload from CLI"
        onSecondaryButtonClick={() => {
          dispatch(
            openModal({
              type: ModalTypesEnum.CONNECTION_INSTRUCTIONS,
              payload: {
                type: ConnectionInstructionsType.DATASET,
                instructionsConfig: {
                  awsRegion: datasetConnection?.aws_region || '',
                  accessKeyId: datasetConnection?.access_key_id || '',
                  secretAccessKey: datasetConnection?.secret_access_key || '',
                  sessionToken: datasetConnection?.session_token || '',
                  bucketName: datasetConnection?.bucket_name || '',
                },
              },
            }),
          );
        }}
      />
    </Box>
  );
};

export default ImportDataStep;
